var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',[_c('b-row',[_c('b-col',{attrs:{"offset":"3","cols":"6"}},[(_vm.store.state[_vm.STORE_MODULE_NAME].elementInEdit == null)?_c('bridge-add-form'):_c('bridge-update-form')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }